/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import { useEffect, useState } from 'react';

// Component imports
import { Grid } from 'antd';

// Constant declarations
const { useBreakpoint } = Grid;

// Returns the current screen breakpoint (xs, sm, md, lg, xl, xxl)
export const useCurrentBreakpoint = () => {
  const screens = useBreakpoint();
  const [currentBreakpoint, setCurrentBreakpoint] = useState();

  useEffect(() => {
    const firstMatch = screens && Object.entries(screens).length > 0 ? Object.entries(screens).reverse().find(([_key, value]) => value === true) : null;
    const breakpoint = firstMatch ? firstMatch[0] : null;

    // Only change breakpoints if there is a value, otherwise just keep the previous breakpoint
    // Sometimes useBreakpoint returns all screens as false, which is why we need this check
    if (breakpoint) {
      setCurrentBreakpoint(breakpoint);
    }
  }, [screens]);

  return currentBreakpoint;
};
